import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
	TranslatedString,
	LocallySortedAndPaginatedTable,
	makeLocallySortedAndPaginatedTableColumnHeader,
	useAjax,
	XhrStatus,
	PrimaryButton,
	InputField,
	DateTimePicker,
	Card,
	formUpdateFieldValues,
	Checkbox,
	Dropdown,
	CommandBar
} from '@bosch/bt-ui';
import 'react-datepicker/dist/react-datepicker.css';
import './UserActionDetailPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import fileDownload from 'js-file-download';
import RadioOptions from '../sim-activation-detail-page/RadioComponent/RadioOptions';
import { prepareLogData } from '../../components/Util';

const convertUTCHours = (hours) => {
	if (parseInt(hours) > 0) {
		return -Math.abs(hours);
	}
	else {
		return Math.abs(hours);
	}
}

const getEstOffset = () => {
	const stdTimezoneOffset = () => {
		var jan = new Date(0, 1)
		var jul = new Date(6, 1)
		return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
	}

	var today = new Date();

	const isDstObserved = (today) => {
		return today.getTimezoneOffset() < stdTimezoneOffset()
	}
	console.log(isDstObserved(today));

	if (isDstObserved(today)) {
		return 4
	} else {
		return 5
	}
}


const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
var timezoneOffset = currentTimeZone === 'America/New_York' ? convertUTCHours(getEstOffset()).toString() : convertUTCHours(new Date().getTimezoneOffset() / 60).toString();
timezoneOffset = parseInt(timezoneOffset) > 0 ? '+' + timezoneOffset : timezoneOffset;

const TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('Email', 'Email'),
	makeLocallySortedAndPaginatedTableColumnHeader('ActionPage', 'Action Page'),
	makeLocallySortedAndPaginatedTableColumnHeader('ActionDescription', 'Action Description'),
	makeLocallySortedAndPaginatedTableColumnHeader('Date', 'Date(UTC +00:00)'),
	makeLocallySortedAndPaginatedTableColumnHeader('LocalDate', 'Local Time(UTC ' + timezoneOffset + ':00)'),
	makeLocallySortedAndPaginatedTableColumnHeader('TransactionId', 'TransactionID'),
];

function getData(getUserActionStatus, searchField, token) {
	var email = searchField.email;
	var transactionID = searchField.transactionID;
	const start = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.startDate).replace('/', '-').replace('/', '-');
	const end = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.endDate).replace('/', '-').replace('/', '-');
	var timeOffset = new Date().getTimezoneOffset();
	var allTime = searchField.allTime;

	const data = {
		'email': email,
		'transactionID': transactionID,
		'sDate': start,
		'eDate': end,
		'timeOffset': timeOffset,
		'allTime': allTime
	}

	getUserActionStatus('GET', SUPPORTCONSOLE_API_URL + '/api/useractiondetail/v1/details', data, undefined, { 'Authorization': 'Bearer ' + token.token });
}

const UserActionDetailPage = (props) => {
	const {
		token,
	} = props;

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const txid = urlParams.get('txid');
	const [hideRobotCheckBox, setHideRobotCheckBox] = useState(true);
	const [showAllTimeCheckBox, setShowAllTimeCheckBox] = useState(false);
	const [lastSearchSimId, setLastSearchSimId] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [hideDownload, setHideDownload] = useState(true);
	const [queryType, setQueryType] = React.useState(txid == null ? 'Email' : 'TransactionID');
	const [errorState, setErrorState] = useState(false);
	const [searchErrorMessage, setSearchErrorMessage] = useState('');
	const [pageresult, setResult] = useState([]);

	const initialSearchField = useMemo(() => {
		const date = new Date();
		return {
			startDate: new Date(date.setDate(date.getDate() - 7)),
			endDate: new Date(Date.now()),
			email: '',
			transactionID: txid == null ? '' : txid,
			allTime: false
		};
	}, [txid]);
	
	const [searchField, updateFormValues] = useReducer(formUpdateFieldValues, initialSearchField);
	const [result, status, getUserActionStatus, response] = useAjax(XhrStatus.InProgress);

	const handleClick = useCallback(() => {
		const start_date = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.startDate).replace('/', '-').replace('/', '-');
		const end_date = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.endDate).replace('/', '-').replace('/', '-');
		var data;
		setCurrentPage(1);
		setShowAllTimeCheckBox(true);
		setLastSearchSimId(searchField.email);
		if (queryType === 'TransactionID')
		{
			data = prepareLogData(token,'User_Action_Detail', 'User Action Detail->Query TransactionID: ' + searchField.transactionID);
			setErrorState(true);
			if (searchErrorMessage == null)
			{
				getData(getUserActionStatus, searchField, token);
			}
		}
		else
		{
			data =prepareLogData(token,'User_Action_Detail', 'User Action Detail->Query Email : ' + searchField.email + ' StartDate:' + start_date + ' EndDate:' + end_date);
			getData(getUserActionStatus, searchField, token);
		}
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
	}, [getUserActionStatus, searchField, token, searchErrorMessage, queryType]);

	const handleCsvDownloadClick = () => {
		let cvsRows = (pageresult?.data) ? pageresult.data.map(item => makeJsonRow(item)) : [];
		fileDownload('Email,ActionPage,UTCDate,LocalDate,TransactionID,ActionDescription' + cvsRows.join(''), 'UserActionLogEx.csv');
	}
	useEffect(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				getData(getUserActionStatus, initialSearchField, token);
			}
		},
		[getUserActionStatus, initialSearchField, token]
	);


	useEffect(
		() => {
			if (searchField.email !== '' && searchField.email === lastSearchSimId) {
				setShowAllTimeCheckBox(true);
			}
			else {
				setShowAllTimeCheckBox(false);
				searchField.allTime = false;
			}

			if (searchField.allTime === true && searchField.email === lastSearchSimId) {
				getData(getUserActionStatus, searchField, token);
			}

		}, [getUserActionStatus, searchField, token, lastSearchSimId, showAllTimeCheckBox]
	);

	useEffect(
		() => {
			setErrorState(false);
			if (queryType === 'Email') {
				searchField.transactionID = '';
			}
			else if (queryType === 'TransactionID') {
				searchField.email = '';
			}
		},
		[queryType, searchField]
	);

	function makeRow(task) {
		const {
			transactionId,
			email,
			status,
			statusDesc,
			date,
			localDate,
			subRows
		} = task;
		return {
			key: transactionId,
			columns: [
				{
					key: 'Email',
					columnContent: email
				},
				{
					key: 'ActionPage',
					columnContent: status
				},
				{
					key: 'ActionDescription',
					columnContent: statusDesc
				},
				{
					key: 'Date',
					columnContent: date
				},
				{
					key: 'LocalDate',
					columnContent: localDate
				},
				{
					key: 'TransactionID',
					columnContent: transactionId
				}
			],

			htmlAttributes: {
				className: status.startsWith('Error') ? 'error-row' : ''
			},
			subRows:
				subRows.filter(item => item.date !== date).map(subRow => {
					return {
						key: uuidv4(),
						columns: [
							{
								key: 'Email',
								columnContent: ' '
							},
							{
								key: 'ActionPage',
								columnContent: subRow.status
							},
							{
								key: 'ActionDescription',
								columnContent: subRow.statusDesc
							},
							{
								key: 'Date',
								columnContent: subRow.date
							},
							{
								key: 'LocalDate',
								columnContent: subRow.localDate
							},
							{
								key: 'TransactionID',
								columnContent: ' '
							}
						]
					};
				})
		};
	}
	// Convert date string to ISO 8601 format
	function convertToISO(dateStr) {
		// Split the date and time parts
		const [date, time] = dateStr.split(' ');
  
		// Replace slashes with hyphens in the date part
		const isoDate = date.replace(/\//g, '-');
  
		// Combine the date and time parts with a "T" separator
		return `${isoDate}T${time}`;
  	}
	function makeJsonRow(task) {
		const {
		  transactionId,
		  email,
		  status,
		  statusDesc,
		  date,
		  localDate
		} = task;
	  	  
		return `\n${email},${status},${date},${localDate},${transactionId},${statusDesc}`;
	}
	  	
	const rows = useMemo(
		() => {
			let newdata = {... result};
			if (result != null)
			{
				if (hideRobotCheckBox === true ) //Activate
				{				
					newdata.data = newdata.data.filter(item=>!item.email.includes('operator.devops@tw.bosch.com'));
				}
			}
			const Rows = (newdata?.data) ? newdata.data.map(item => makeRow(item)) : [];
			if (Rows.length > 0) {
				setHideDownload(false);
			}
			else {
				setHideDownload(true);
			}
			setResult(newdata);
			setCurrentPage(1);
			return Rows;
		},
		[result,hideRobotCheckBox]
	);

	return (
		<Card
			htmlAttributes={{
				id: 'user-action-detail-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={result} hideSuccess={true} />
			<div className='panel-radio-options'>
					<RadioOptions
						label="Email"
						fieldName="email-radio"
						value={queryType === 'Email'}
						onChange={() => {setQueryType('Email')}}
					/>
					<RadioOptions
						label="TransactionID"
						fieldName="transactionID-radio"
						value={queryType === 'TransactionID'}
						onChange={() => {setQueryType('TransactionID')}}
					/>
			</div>
			{ queryType === 'Email' ? 
				(<div className="Input-field">
					<InputField
						inputType="text"
						fieldName="email"
						label="Email"
						htmlAttributes={{
							onChange: updateFormValues,
							value: searchField.email
						}}
					/>
					<div>
						<span>Start Date </span>
						<DateTimePicker
							inputFieldAttributes={{
								fieldName: 'startDate'
							}}
							value={searchField.startDate}
							onChange={updateFormValues}
							allowDateToBeCleared={false}
							disabled={searchField.allTime}
						/>
					</div>
					<div>
						<span>End Date </span>
						<DateTimePicker
							inputFieldAttributes={{
								fieldName: 'endDate'
							}}
							value={searchField.endDate}
							onChange={updateFormValues}
							allowDateToBeCleared={false}
							disabled={searchField.allTime}
						/>
					</div>
					<PrimaryButton
						onClick={handleClick}>
						<TranslatedString stringId="Search" />
					</PrimaryButton>
					{showAllTimeCheckBox ? (
						<Checkbox
							fieldName="allTime"
							label="All Time"
							htmlAttributes={{
								onChange: updateFormValues,
								checked: searchField.allTime ?? false
							}}
						/>) : null
					}
				<Checkbox
					fieldName="hiderobot"
					label="HideRobot"
					htmlAttributes={{
						onChange: update => {
							setHideRobotCheckBox(update.value);
						},
						checked: hideRobotCheckBox ?? false
					}}
				/>
				</div>) : 
				<div className="Input-field">
					<InputField
						inputType="text"
						fieldName="transactionID"
						label="TransactionID"
						shouldAlwaysShowErrors={errorState}
						validationError={searchErrorMessage}
						onValidationError={(update) => {
							setSearchErrorMessage(update.value);
						}}
						htmlAttributes={{
							onChange: updateFormValues,
							value: searchField.transactionID,
							required: true
						}}
					/>
					<PrimaryButton
						onClick={handleClick}>
						<TranslatedString stringId="Search" />
					</PrimaryButton>
				</div>
			}
			{
				<LocallySortedAndPaginatedTable
					headers={TABLE_HEADERS}
					rows={rows}
					numRowsPerPage={100}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'user-activation-detail-table'
					}}
					errorMessage="Error occured"
					noResultsMessage={<TranslatedString stringId="No User Action Data found" />}
				/>

			}
			<CommandBar
				actions={
					<div>
						<PrimaryButton type="submit" style={{ display: hideDownload === true ? 'none' : 'inline' }}
							onClick={handleCsvDownloadClick}>Download</PrimaryButton>
					</div>
				}
			/>

			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(UserActionDetailPage));
